module.exports = __webpack_public_path__ + "img/ibisa.09e8f8c6.jpg";